import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    readAllWarehouses,
    createWarehouse,
    updateWarehouse,
    deleteWarehouse,
} from '../../helpers';
import {
    warehouseApiResponseSuccess,
    warehouseApiResponseError,
    warehouseGetAllWarehouses,
} from './actions';
import { WarehousesActionTypes } from './constants';
import {
    warehouseResponseToWarehouseObject,
    warehouseObjectToWarehouseRequest,
} from '../../helpers/mappers/warehouse';

export function* readAllWarehousesSaga({ payload: { query } }) {
    try {
        const response = yield call(readAllWarehouses, query);
        const warehouseEntries = response.data.map((warehouseResponse) =>
            warehouseResponseToWarehouseObject(warehouseResponse)
        );
        yield put(warehouseApiResponseSuccess(WarehousesActionTypes.READ_ALL_WAREHOUSES_REQUEST, warehouseEntries));
    } catch (error) {
        yield put(warehouseApiResponseError(WarehousesActionTypes.READ_ALL_WAREHOUSES_REQUEST, error));
    }
}

export function* createWarehouseSaga({ payload: { warehouse, callback } }) {
    try {
        const warehouseRequest = warehouseObjectToWarehouseRequest(warehouse);
        const response = yield call(createWarehouse, warehouseRequest);
        const warehouseResponse = warehouseResponseToWarehouseObject(response);
        yield put(warehouseApiResponseSuccess(WarehousesActionTypes.CREATE_WAREHOUSE_REQUEST, warehouseResponse));
        yield put(warehouseGetAllWarehouses());
    } catch (error) {
        yield put(warehouseApiResponseError(WarehousesActionTypes.CREATE_WAREHOUSE_REQUEST, error));
    } finally {
        callback?.();
    }
}

function* updateWarehouseSaga({ payload: { warehouseId, warehouse } }) {
    try {
        const warehouseRequest = warehouseObjectToWarehouseRequest(warehouse);
        const response = yield call(updateWarehouse, warehouseId, warehouseRequest);
        const warehouseResponse = warehouseResponseToWarehouseObject(response);
        yield put(warehouseApiResponseSuccess(WarehousesActionTypes.UPDATE_WAREHOUSE_REQUEST, warehouseResponse));
        yield put(warehouseGetAllWarehouses());
    } catch (error) {
        yield put(warehouseApiResponseError(WarehousesActionTypes.UPDATE_WAREHOUSE_REQUEST, error));
    }
}

function* deleteWarehouseSaga({ payload: { warehouseId } }) {
    try {
        // response should be HTTP success with empty body
        const response = yield call(deleteWarehouse, warehouseId);
        yield put(warehouseApiResponseSuccess(WarehousesActionTypes.DELETE_WAREHOUSE_REQUEST, response));
        yield put(warehouseGetAllWarehouses());
    } catch (error) {
        yield put(warehouseApiResponseError(WarehousesActionTypes.DELETE_WAREHOUSE_REQUEST, error));
    }
}

export function* watchReadAllWarehousesSaga() {
    yield takeLatest(WarehousesActionTypes.READ_ALL_WAREHOUSES_REQUEST, readAllWarehousesSaga);
}

export function* watchCreateWarehouseSaga() {
    yield takeLatest(WarehousesActionTypes.CREATE_WAREHOUSE_REQUEST, createWarehouseSaga);
}

export function* watchUpdateWarehouseSaga() {
    yield takeLatest(WarehousesActionTypes.UPDATE_WAREHOUSE_REQUEST, updateWarehouseSaga);
}

export function* watchDeleteWarehouseSaga() {
    yield takeLatest(WarehousesActionTypes.DELETE_WAREHOUSE_REQUEST, deleteWarehouseSaga);
}

function* warehouseSaga() {
    yield all([
        fork(watchReadAllWarehousesSaga),
        fork(watchCreateWarehouseSaga),
        fork(watchUpdateWarehouseSaga),
        fork(watchDeleteWarehouseSaga),
    ]);
}

export default warehouseSaga;
